export default {"src":"/_next/static/media/mileprogram-benefit-01.c0099b96.svg","height":151,"width":150,"blurWidth":0,"blurHeight":0};